import type { ModuleMigrationDef } from "@kubdee/sdk";

const INVOICE_COLUMNS = `
  \`id\`, \`invoice_no\`, \`company_id\`, \`branch_id\`, \`invoice_type\`, \`party_type\`, \`party_id\`,
  \`invoice_date\`, \`due_date\`, \`subtotal\`, \`tax_amount\`, \`total_discount\`, \`total_wht\`,
  \`total\`, \`outstanding\`, \`doc_status\`, \`status\`, \`credit_note_of\`, \`debit_note_of\`,
  \`reason\`, \`original_invoice_amount\`, \`corrected_amount\`, \`difference_amount\`, \`reason_code\`,
  \`currency_code\`, \`exchange_rate\`, \`transaction_type\`, \`delivery_date\`, \`tax_point_date\`,
  \`vat_status\`, \`vat_period\`, \`remarks\`, \`reference_module\`, \`reference_doctype\`,
  \`reference_id\`, \`created_by\`, \`created_at\`, \`updated_at\`, \`updated_by\`, \`deleted_at\`,
  \`deleted_by\`
`;

function backfillSql(
  targetTable: string,
  sourceTable: string,
  invoiceType: string,
  partyType: string,
): string {
  return `
INSERT INTO \`${targetTable}\` (${INVOICE_COLUMNS})
SELECT ${INVOICE_COLUMNS}
FROM \`${sourceTable}\`
WHERE \`invoice_type\` = '${invoiceType}'
  AND \`party_type\` = '${partyType}'
ON CONFLICT(\`id\`) DO UPDATE SET
  \`invoice_no\` = excluded.\`invoice_no\`,
  \`company_id\` = excluded.\`company_id\`,
  \`branch_id\` = excluded.\`branch_id\`,
  \`invoice_type\` = excluded.\`invoice_type\`,
  \`party_type\` = excluded.\`party_type\`,
  \`party_id\` = excluded.\`party_id\`,
  \`invoice_date\` = excluded.\`invoice_date\`,
  \`due_date\` = excluded.\`due_date\`,
  \`subtotal\` = excluded.\`subtotal\`,
  \`tax_amount\` = excluded.\`tax_amount\`,
  \`total_discount\` = excluded.\`total_discount\`,
  \`total_wht\` = excluded.\`total_wht\`,
  \`total\` = excluded.\`total\`,
  \`outstanding\` = excluded.\`outstanding\`,
  \`doc_status\` = excluded.\`doc_status\`,
  \`status\` = excluded.\`status\`,
  \`credit_note_of\` = excluded.\`credit_note_of\`,
  \`debit_note_of\` = excluded.\`debit_note_of\`,
  \`reason\` = excluded.\`reason\`,
  \`original_invoice_amount\` = excluded.\`original_invoice_amount\`,
  \`corrected_amount\` = excluded.\`corrected_amount\`,
  \`difference_amount\` = excluded.\`difference_amount\`,
  \`reason_code\` = excluded.\`reason_code\`,
  \`currency_code\` = excluded.\`currency_code\`,
  \`exchange_rate\` = excluded.\`exchange_rate\`,
  \`transaction_type\` = excluded.\`transaction_type\`,
  \`delivery_date\` = excluded.\`delivery_date\`,
  \`tax_point_date\` = excluded.\`tax_point_date\`,
  \`vat_status\` = excluded.\`vat_status\`,
  \`vat_period\` = excluded.\`vat_period\`,
  \`remarks\` = excluded.\`remarks\`,
  \`reference_module\` = excluded.\`reference_module\`,
  \`reference_doctype\` = excluded.\`reference_doctype\`,
  \`reference_id\` = excluded.\`reference_id\`,
  \`created_by\` = excluded.\`created_by\`,
  \`created_at\` = excluded.\`created_at\`,
  \`updated_at\` = excluded.\`updated_at\`,
  \`updated_by\` = excluded.\`updated_by\`,
  \`deleted_at\` = excluded.\`deleted_at\`,
  \`deleted_by\` = excluded.\`deleted_by\`;
  `.trim();
}

export const migration: ModuleMigrationDef = {
  key: "009_backfill_accounting_invoice_owner_tables",
  version: "1.9.0",
  ignoreErrors: [
    "no such table: accounting_purchase_invoices",
    "no such table: accounting_purchase_debit_notes",
    "no such table: purchase_invoices",
    "no such table: purchase_debit_notes",
  ],
  sql: `
${backfillSql("accounting_purchase_invoices", "purchase_invoices", "purchase", "supplier")}

${backfillSql("accounting_purchase_debit_notes", "purchase_debit_notes", "debit_note", "supplier")}
  `.trim(),
};
